<template>
  <grid-container class="text-center">
    <p>Felicitări pentru finalizarea evaluării!</p>

    <p>Acum puteți vedea rezultatele evaluării dvs. făcând clic pe butonul de mai jos!</p>

    <p>Vă mulțumim și sperăm că v-a plăcut experiența!</p>

    <el-button @click="viewResults" type="primary">
      Vezi Resultate
    </el-button>
  </grid-container>
</template>

<script>
export default {
  name: 'Completed',
  computed: {
    siteUrl() {
      return process.env.VUE_APP_DASHBOARD_SJT_SCREEN
    }
  },
  methods: {
    viewResults() {
      window.location = this.siteUrl
    }
  }
}
</script>

<style scoped>
  .container p {
    margin: 24px 0;
  }
</style>
